export const UserRole = {
    Basic: 10,
    Extended: 20,
    Full: 30,
    Assistant: 40,
    SubstituteBusinessman: 50,
    Tipster: 60,
    SpecialUser: 100,
    OuSupervizor: 110
} as const

export type UserRole = typeof UserRole[keyof typeof UserRole]